import { Text } from '@chakra-ui/react';
import React from 'react';
import { CopyIcon, DropdownItem } from 'ui-components';
import { ICreator } from '~/types';

interface CopyEmbedDropdownItemProps {
  creator: ICreator;
  onBasicCopy: (e: React.MouseEvent) => Promise<void> | void;
  onDetailCopy: (e: React.MouseEvent) => Promise<void> | void;
}

//Copied from components/TalentDropdownMenu
export function CopyEmbedDropdownItem({
  creator,
  onBasicCopy,
  onDetailCopy,
}: CopyEmbedDropdownItemProps) {
  return (
    <>
      <DropdownItem onClick={onBasicCopy} trackId="wm-creator-copy-basic-embed">
        <CopyIcon boxSize={4} />
        <Text>Copy Basic Embed</Text>
      </DropdownItem>

      {!creator.isOffPlatform && creator.hasConnectedPlatform && (
        <DropdownItem onClick={onDetailCopy}>
          <CopyIcon boxSize={4} />
          <Text>Copy Detail Embed</Text>
        </DropdownItem>
      )}
    </>
  );
}
